import React from 'react';
import {CheckBox, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';
import {useHover} from '../../../hooks/useHover';
import {helpPopoverRef} from '../../../_shared/Help/constants';

interface CheckBoxItemProps {
    title: string;
    isChecked: boolean;
    onClick: () => void;
    helpText?: string;
}

const handleCheckBoxHelp = (e, helpText) => {
    e.stopPropagation();
    helpPopoverRef.current.showHelpPopover({content: helpText, anchor: e.target});
};

export const CheckBoxItem = ({title, isChecked, onClick, helpText}: CheckBoxItemProps) => {
    const {setRef, isHovering} = useHover();

    return (
        <div ref={setRef}>
            <CheckBox onChange={onClick} checked={isChecked}>
                <>
                    {title}
                    {helpText && (
                        <div className={styles.helpIconWrapper}>
                            {isHovering && (
                                <Icon
                                    onClick={e => handleCheckBoxHelp(e, helpText)}
                                    skin="standart"
                                    icon={PriorityIcon.help}
                                />
                            )}
                        </div>
                    )}
                </>
            </CheckBox>
        </div>
    );
};
